import { RoleNameKeyMap } from "../../helpers/constants";

export const RoutesSlugs = {
	auth: {
		home: '/',
		login: '/login',
		resetPassword: '/reset-password'
	},
	dashboard: '/dashboard',
	assets: {
		list: '/assets',
		upload: '/upload',
		details: '/asset-details'
	},
	regions: {
		list: '/regions'
	},
	devices: {
		list: '/devices',
		details: '/device-details'
	},
	users: {
		list: '/users',
	},
	auditLogs: '/logs',
	systemLogs: '/system-logs',
	settings: '/settings'
}

export const MenuPageNames = {
	[RoutesSlugs.auth.login]: 'Login',
	[RoutesSlugs.auth.resetPassword]: 'Reset Password',
	[RoutesSlugs.dashboard]: 'Dashboard',
	[RoutesSlugs.assets.list]: 'Digital Assets',
	[RoutesSlugs.regions.list]: 'Regions',
	[RoutesSlugs.devices.list]: 'CORI-XT Devices',
	[RoutesSlugs.users.list]: 'Users',
	[RoutesSlugs.systemLogs]: 'System Logs',
	[RoutesSlugs.auditLogs]: 'Audit Logs',
	[RoutesSlugs.settings]: 'Settings'
}

export const getRouteSlugs = (module) => {
	if (typeof RoutesSlugs[module] === 'string') {
		return [RoutesSlugs[module]]
	}

	var slugsList = [];
	for (const key in RoutesSlugs[module]) {
		if (Object.prototype.hasOwnProperty.call(RoutesSlugs[module], key)) {
			const element = RoutesSlugs[module][key];
			slugsList.push(element)
		}
	}
	return slugsList;
}

export const RoutesPerModule = {
	auth: getRouteSlugs('auth'),
	dashboard: getRouteSlugs('dashboard'),
	assets: getRouteSlugs('assets'),
	regions: getRouteSlugs('regions'),
	devices: getRouteSlugs('devices'),
	users: getRouteSlugs('users'),
	auditLogs: getRouteSlugs('auditLogs'),
	systemLogs: getRouteSlugs('systemLogs'),
	settings: getRouteSlugs('settings')
}

export const definedRoutesForRoles = {
	common: [
		...RoutesPerModule.auth,
		...RoutesPerModule.dashboard,
		...RoutesPerModule.settings
	],
	[RoleNameKeyMap.engineer]: [
		...RoutesPerModule.assets,
		...RoutesPerModule.devices,
		...RoutesPerModule.regions,
		...RoutesPerModule.systemLogs
	],
	[RoleNameKeyMap.admin]: [
		...RoutesPerModule.auditLogs,
		...RoutesPerModule.users
	],
	[RoleNameKeyMap.complaints]: [
		...RoutesPerModule.auditLogs,
		...RoutesPerModule.devices,
		...RoutesPerModule.regions,
		...RoutesPerModule.systemLogs
	],
	[RoleNameKeyMap.service]: [
		...RoutesPerModule.auditLogs,
		...RoutesPerModule.devices,
		...RoutesPerModule.regions,
		...RoutesPerModule.systemLogs
	],
	[RoleNameKeyMap.rNd]: [
		...RoutesPerModule.assets,
		...RoutesPerModule.devices,
		...RoutesPerModule.regions,
		...RoutesPerModule.systemLogs
	],
	[RoleNameKeyMap.fieldStaff]: [
		...RoutesPerModule.systemLogs
	],	
	[RoleNameKeyMap.contractor]: [
		...RoutesPerModule.assets,
		...RoutesPerModule.devices,
		...RoutesPerModule.regions
	],
}

export const RoleDefaultRedirect = {
	default: RoutesSlugs.dashboard,
	[RoleNameKeyMap.engineer]: RoutesSlugs.assets.list,
	[RoleNameKeyMap.admin]: RoutesSlugs.dashboard
}

// Privilege pages for RolePrivileges component
export const privilegePages = [
  { key: "assets", label: "Digital Assets", route: RoutesSlugs.assets.list },
  { key: "regions", label: "Regions", route: RoutesSlugs.regions.list },
  { key: "devices", label: "Cori XT Devices", route: RoutesSlugs.devices.list },
  { key: "systemLogs", label: "(CORI) System Logs (upload and download)", route: RoutesSlugs.systemLogs },
  { key: "settings", label: "Settings", route: RoutesSlugs.settings },
  { key: "auditLogs", label: "(DAP) Audit Logs", route: RoutesSlugs.auditLogs },
  { key: "dashboard", label: "Dashboard", route: RoutesSlugs.dashboard },
  { key: "users", label: "Users", route: RoutesSlugs.users.list },
];

// Privilege roles for RolePrivileges component
export const privilegeRoles = [
  { key: RoleNameKeyMap.complaints, label: "Complaints" },
  { key: RoleNameKeyMap.rNd, label: "R&D User (SW/V&V/Systems)" },
  { key: RoleNameKeyMap.engineer, label: "Manufacturing Engineer (DAP)" },
  { key: RoleNameKeyMap.engineer+"_sn", label: "Manufacturing Engineer (S+N)" },
  { key: RoleNameKeyMap.contractor, label: "Manufacture Contractor" },
  { key: RoleNameKeyMap.fieldStaff, label: "S+N Field Staff" },
  { key: RoleNameKeyMap.service, label: "Service Staff" },
  { key: RoleNameKeyMap.admin, label: "Admin (DAP)" },
  { key: RoleNameKeyMap.admin+"_sn", label: "Admin (S+N)" }
];

// Privilege matrix based on the role
export const rolePrivileges = {
  [RoleNameKeyMap.complaints]: {
    assets: false,
    regions: true,
    devices: true,
    systemLogs: true,
    settings: false,
    auditLogs: true,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.rNd]: {
    assets: true,
    regions: true,
    devices: true,
    systemLogs: true,
    settings: false,
    auditLogs: false,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.engineer]: {
    assets: true,
    regions: true,
    devices: true,
    systemLogs: true,
    settings: true,
    auditLogs: false,
    dashboard: false,
    users: false,
  },
  [RoleNameKeyMap.engineer+"_sn"]: {
    assets: true,
    regions: true,
    devices: true,
    systemLogs: true,
    settings: false,
    auditLogs: false,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.contractor]: {
    assets: true,
    regions: true,
    devices: true,
    systemLogs: false,
    settings: false,
    auditLogs: false,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.fieldStaff]: {
    assets: false,
    regions: false,
    devices: false,
    systemLogs: true,
    settings: false,
    auditLogs: false,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.service]: {
    assets: false,
    regions: true,
    devices: true,
    systemLogs: true,
    settings: false,
    auditLogs: true,
    dashboard: false,
    users: false,
  },

  [RoleNameKeyMap.admin]: {
    assets: false,
    regions: false,
    devices: false,
    systemLogs: false,
    settings: true,
    auditLogs: true,
    dashboard: true,
    users: true,
  },
  [RoleNameKeyMap.admin+"_sn"]: {
    assets: false,
    regions: false,
    devices: false,
    systemLogs: false,
    settings: false,
    auditLogs: true,
    dashboard: true,
    users: true,
  },
};